import axios from './../../config/axios';

export function createJournalVoucher(payload, dpk) {
    return axios().post(`/journal/journal-voucher`, payload, { headers: {Dpk: dpk} });
}

/**
 * Fetch Journal Voucher data from server.
 * 
 * @param {Number} id The Journal Voucher ID
 */
export function getJournalVoucherById(id) {
    return axios().get(`/journal/journal-voucher/${id}`);
}

export function updateJournalVoucher(payload) {
    return axios().put(`/journal/journal-voucher/${payload.id}`, payload);
}

export function postJournalVoucher(id, dpk) {
    return axios().post(`/journal/journal-voucher/${id}/post`, {}, { headers: {Dpk: dpk} });
}

export function reverseJournalVoucher(id, dpk) {
    return axios().post(`/journal/journal-voucher/${id}/reverse`, {}, { headers: {Dpk: dpk} });
}